import Swiper from 'swiper/bundle';

const equalizeSlideHeights = (swiper) => {
  swiper.slides.forEach(s => (s.style.height = 'auto'));
  let max = 0;
  swiper.slides.forEach(s => { max = Math.max(max, s.offsetHeight); });
  swiper.slides.forEach(s => (s.style.height = `${max}px`));
};

/* Slider with offset on mobile and desktop */
const swiperContainerOffsetMobile = document.querySelector('.swiper-offset-mobile');
if (swiperContainerOffsetMobile) {
  const swiper = new Swiper('.swiper-offset-mobile', {
    slidesPerView: 'auto',
    spaceBetween: 20,
    slidesPerGroup: 1,
    direction: 'horizontal',
    loop: true,

    // Set equal height for all slides
    on: {
      init(sw) { equalizeSlideHeights(sw); },
      resize(sw) { equalizeSlideHeights(sw); },
    },

    // TODO: tbd
    // pagination: {
    //   el: '.swiper-pagination',
    //   clickable: true
    // },

    navigation: {
      nextEl: '.custom-swiper-button-next',
      prevEl: '.custom-swiper-button-prev',
    },

    // TODO: tbd
    // autoplay: {
    //   delay: 5000,
    //   pauseOnMouseEnter: true
    // },

    watchOverflow: true,
    // TODO: Check if this breakpoints are okay
    breakpoints: {
      0:   {
        slidesPerView: 'auto',
        spaceBetween: 20,
        slidesOffsetBefore: 20, // left padding
      },
      1440: {
        slidesPerView: 'auto',
        spaceBetween: 20,
        slidesOffsetBefore: 100, // left padding
      }
    }
  });
}

/* Slider with offset only on desktop */
const swiperContainerNoOffsetMobile = document.querySelector('.swiper-nooffset-mobile');
if (swiperContainerNoOffsetMobile) {
  const swiper = new Swiper('.swiper-nooffset-mobile', {
    slidesPerView: 'auto',
    spaceBetween: 20,
    slidesPerGroup: 1,
    direction: 'horizontal',
    loop: true,

    // Set equal height for all slides
    on: {
      init(sw) { equalizeSlideHeights(sw); },
      resize(sw) { equalizeSlideHeights(sw); },
    },

    // TODO: tbd
    // pagination: {
    //   el: '.swiper-pagination',
    //   clickable: true
    // },

    navigation: {
      nextEl: '.custom-swiper-button-next',
      prevEl: '.custom-swiper-button-prev',
    },

    // TODO: tbd
    // autoplay: {
    //   delay: 5000,
    //   pauseOnMouseEnter: true
    // },

    watchOverflow: true,
    // TODO: Check if this breakpoints are okay
    breakpoints: {
      0:   {
        slidesPerView: 1,
        spaceBetween: 20,
      },
      640: {
        slidesPerView: 'auto',
        spaceBetween: 20,
        slidesOffsetBefore: 20, // left padding
      },
      1440: {
        slidesPerView: 'auto',
        spaceBetween: 20,
        slidesOffsetBefore: 100, // left padding
      }
    }
  });
}

const uriHash = decodeURIComponent(window.location.hash.replace(/^#/, ''));

const allRegionInformationElements = document.querySelectorAll(".region-info");

const closeHideableContentOfAllRegionInfoElements = () => {
  allRegionInformationElements.forEach((informationElement) => {
    const hideableContent = informationElement.querySelector(".hideable-content");
    const linkElement = informationElement.querySelector(".link-element");
    const openButton = informationElement.querySelector(".open-button");
    const closeButton = informationElement.querySelector(".close-button");
    hideableContent.classList.remove('open');
    hideableContent.style.maxHeight = null;
    openButton.classList.remove('hidden');
    closeButton.classList.add('hidden');

    if (linkElement) {
      linkElement.classList.add('margin-bottom-mobile');
    }
  })
};

const handleUriHash = (hash) => {
  const regionInformationElement = document.querySelector("#" + hash);

  if (regionInformationElement && regionInformationElement.classList.contains('region-info')) {
    const hideableContent = regionInformationElement.querySelector(".hideable-content");
    const linkElement = regionInformationElement.querySelector(".link-element");
    const openButton = regionInformationElement.querySelector(".open-button");
    const closeButton = regionInformationElement.querySelector(".close-button");

    closeHideableContentOfAllRegionInfoElements();
    hideableContent.classList.add('open');
    hideableContent.style.maxHeight = `${hideableContent.scrollHeight}px`;
    openButton.classList.add('hidden');
    closeButton.classList.remove('hidden');

    if (linkElement) {
      linkElement.classList.remove('margin-bottom-mobile');
    }
  }

  const accordionSectionElement = document.querySelector("#" + hash);
  if (accordionSectionElement && accordionSectionElement.classList.contains('accordion-section')) {
    const body = accordionSectionElement.querySelector('.accordion-section-body');
    if (body && !body.classList.contains('no-animation')) {
      // single-open: close all other sections first (matches click behaviour)
      document.querySelectorAll('.accordion-section').forEach(i => {
        i.classList.remove('open');
        const b = i.querySelector('.accordion-section-body');
        if (b) b.style.maxHeight = null;
      });
      accordionSectionElement.classList.add('open');
      body.style.maxHeight = `${body.scrollHeight}px`;
    }
  }
}

if (allRegionInformationElements) {
  allRegionInformationElements.forEach((informationElement) => {
    const openButton = informationElement.querySelector(".open-button");
    const closeButton = informationElement.querySelector(".close-button");

    openButton.addEventListener('click', (event) => {
      event.preventDefault();
      const hideableContent = informationElement.querySelector(".hideable-content");
      const linkElement = informationElement.querySelector(".link-element");
      if (!hideableContent.classList.contains('open')) {
        closeHideableContentOfAllRegionInfoElements();
        hideableContent.classList.add('open');
        hideableContent.style.maxHeight = `${hideableContent.scrollHeight}px`;
      }

      if (linkElement) {
        linkElement.classList.remove('margin-bottom-mobile');
      }
      closeButton.classList.remove('hidden');
      openButton.classList.add('hidden');
    })

    closeButton.addEventListener('click', (event) => {
      event.preventDefault();
      const hideableContent = informationElement.querySelector(".hideable-content");
      const linkElement = informationElement.querySelector(".link-element");
      if (hideableContent.classList.contains('open')) {
        hideableContent.classList.remove('open');
        hideableContent.style.maxHeight = null;
      }

      if (linkElement) {
        linkElement.classList.add('margin-bottom-mobile');
      }
      closeButton.classList.add('hidden');
      openButton.classList.remove('hidden');
    })
  });
}

if (uriHash) {
  handleUriHash(uriHash);
}

function updateAncestorMaxHeights(el) {
  let ancestor = el.parentElement;
  while (ancestor) {
    if (ancestor.classList && ancestor.classList.contains('hideable-content')) {
      if (ancestor.classList.contains('open')) {
        ancestor.style.maxHeight = `${ancestor.scrollHeight}px`;
      }
    }
    ancestor = ancestor.parentElement;
  }
}

function startSyncAncestors(el) {
  let rafId = null;
  let stopped = false;

  function frame() {
    if (stopped) return;
    updateAncestorMaxHeights(el);
    rafId = requestAnimationFrame(frame);
  }

  frame();

  return {
    stop() {
      stopped = true;
      if (rafId) cancelAnimationFrame(rafId);
    }
  };
}

const accordionItems = document.querySelectorAll('.accordion-section');
accordionItems.forEach(item => {
  const header = item.querySelector('.accordion-section-header');
  const content = item.querySelector('.accordion-section-body');

  if (!content.classList.contains('no-animation')) {
    header.addEventListener('click', () => {
      const noAnimation = item.classList.contains('no-animation');
      if (noAnimation) {
        return;
      }

      const isOpen = item.classList.contains('open');

      // This part closes all other accordion items
      accordionItems.forEach(i => {
        i.classList.remove('open');
        i.querySelector('.accordion-section-body').style.maxHeight = null;
      });

      if (!isOpen) {
        item.classList.add('open');
        content.style.maxHeight = `${content.scrollHeight}px`;

        // start syncing ancestors so parents follow during animation
        const sync = startSyncAncestors(content);

        // stop syncing when this hideable finished its transition
        const onEnd = (ev) => {
          if (ev.propertyName === 'max-height') {
            sync.stop();
            updateAncestorMaxHeights(content);
            content.removeEventListener('transitionend', onEnd);
          }
        };
        content.addEventListener('transitionend', onEnd);
      } else {
        // If other items should be closed, remove this else block
        item.classList.remove('open');
        content.style.maxHeight = null;

        // start syncing ancestors so parents follow during animation
        const sync = startSyncAncestors(content);

        // stop syncing when this hideable finished its transition
        const onEnd = (ev) => {
          if (ev.propertyName === 'max-height') {
            sync.stop();
            updateAncestorMaxHeights(content);
            content.removeEventListener('transitionend', onEnd);
          }
        };
      }
    });
  }
});

window.addEventListener('hashchange', () => {
  handleUriHash(decodeURIComponent(window.location.hash.replace(/^#/, '')));
});

// LANGUAGE MENU
const languageMenuItems = document.querySelectorAll('.language-menu');
for (let menuItem of languageMenuItems) {
  const languageSelector = menuItem.querySelector('.language-selector');
  const languageOptions = menuItem.querySelector('.language-options');

  languageSelector.addEventListener('click', () => {
    languageOptions.classList.toggle('hidden');
    languageSelector.classList.toggle('open');
  })

  // Remember the explicitly chosen language, the language-detection Cloudflare worker prefers it over Accept-Language
  for (let languageLink of languageOptions.querySelectorAll('a')) {
    languageLink.addEventListener('click', () => {
      const language = new URL(languageLink.href).pathname.split('/')[1];
      if (language) {
        document.cookie = `alpspass_lang=${language}; Path=/; Max-Age=31536000; SameSite=Lax; Secure`;
      }
    })
  }
}

// MOBILE MENU
const header = document.querySelector('header');
const menuButton = document.querySelector('.menu-button');
const mobileMenu = document.querySelector('.mobile-menu');
const mobileMenuLinks = mobileMenu.querySelectorAll('a');
let menuOpen = false;

const fixedHeaderContainer = document.querySelector('.fixed-header');
const defaultPaddingRight = 20;
const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

menuButton.addEventListener('click', () => {
  menuOpen = !menuOpen;

  if (menuOpen) {
    mobileMenu.classList.remove('hidden');
    menuButton.classList.add('menu-open');
    header.classList.add('h-screen');
    document.body.classList.add('overflow-hidden');
    fixedHeaderContainer.style.paddingRight = `${scrollbarWidth + defaultPaddingRight}px`;
  } else {
    mobileMenu.classList.add('hidden');
    menuButton.classList.remove('menu-open');
    header.classList.remove('h-screen');
    document.body.classList.remove('overflow-hidden');
    fixedHeaderContainer.style.paddingRight = '';
  }
});

for (let mobileMenuLink of mobileMenuLinks) {
  mobileMenuLink.addEventListener('click', () => {
    mobileMenu.classList.add('hidden');
    menuButton.classList.remove('menu-open');
    header.classList.remove('h-screen');
    document.body.classList.remove('overflow-hidden');
    fixedHeaderContainer.style.paddingRight = '';
    menuOpen = false;
  })
}
